import { breakpoints, breakpointsInt, awarenessBreakpoints } from './breakpoints.theme';
import typography from './typography.theme';
import palette from './palette.theme';


const MoTheme = {
    name: "MoTheme",
    breakpoints: {
        ...breakpoints
    },
    breakpointsInt: {
        ...breakpointsInt
    },
    awarenessBreakpoints: {
        ...awarenessBreakpoints
    },
    typography: {
        ...typography
    },
    palette: {
        ...palette
    }
};


export default MoTheme;